/**
 * The category slugs a caller reads BY NAME, and the only ones that do.
 *
 * These two make up the people-search list — the coverage an Essentials licence
 * buys — and everything else in the breakdown is iterated rather than named. A
 * payload that renamed one of them would still be a well-formed object of whole
 * numbers, so nothing would reject it, and `peopleSearchCount` would quietly
 * answer 0: a page publishing "0 People Search Sites" about a list of 517. So
 * the names are part of the contract — required by the type here, and required
 * of a live payload in `endpoint.ts`.
 */
export const PEOPLE_SEARCH_CATEGORIES = ["people_search", "people_search_affiliate"];
